import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";

import { ShipperUpgradeNowButton } from "components/Shipper/components/ShipperUpgradeNowButton";
import { useSubscriptionStatus } from "hooks/useSubscriptionStatus";
import { shipperSubscriptionTierWithoutPrivateShipments } from "utils";

export type ShipmentVisibility = "PUBLIC" | "PRIVATE";

interface VisibilityRadioGroupProps {
  visibility: ShipmentVisibility;
  onVisibilityChange: (visibility: ShipmentVisibility) => void;
}

export function VisibilityRadioGroup(props: VisibilityRadioGroupProps) {
  const { visibility, onVisibilityChange } = props;

  const { subscription } = useSubscriptionStatus();

  if (!subscription) {
    return null;
  }

  const hasLimitedSubscription =
    shipperSubscriptionTierWithoutPrivateShipments(subscription);

  const onRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onVisibilityChange(event.target.value as ShipmentVisibility);
  };

  return (
    <FormControl>
      <RadioGroup value={visibility} onChange={onRadioChange}>
        <FormControlLabel value="PUBLIC" control={<Radio />} label="Public" />
        <Stack direction="row" alignItems="center">
          <FormControlLabel
            value="PRIVATE"
            control={<Radio disabled={hasLimitedSubscription} />}
            label="Private"
          />
          {hasLimitedSubscription && (
            <ShipperUpgradeNowButton
              buttonSize="small"
              trackingSource="create_shipment_form:private_shipment_paywall"
            />
          )}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
}
